var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "device-list" } },
    [
      _c("Titlebar", { attrs: { incrustation: "beepiz-folder" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("device.group.titles.list")))]),
      ]),
      _vm._v(" "),
      _c(
        "UiCard",
        [
          _c("SuperTable", {
            ref: "tableGroups",
            attrs: { tableColumns: _vm.tableColumns, tableData: _vm.tableData },
            on: {
              sort: _vm.handleSort,
              filter: _vm.handleFilter,
              delete: _vm.handleDelete,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("Toolbar", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _vm.useDvFlagAccess("beepiz-group-can:create")
                ? _c(
                    "Btn",
                    { class: "default" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/devices/groups/new", tag: "span" } },
                        [
                          _c("i", { staticClass: "fa fa-plus fa-fw" }),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("device.group.btns.add"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col center" },
            [
              _c("Pagination", {
                ref: "pagination",
                on: { change: _vm.handlePagination },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col" }),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }